// @flow
import client from '../../client'
import { config } from '../../config'
import APIError from '../../client/APIError'
import reservationBuilder from './builders/prebook'
import format from '../../utils/format'
import poller from '../../utils/poller'

// Types
import type { Reservation } from '../../models/reservation'

type Data = Object // FIXME

// Constants
export const CHANGE_RESERVATION_ENDPOINT = '/reservations/changes/'
export const POLL_RESERVATION_ENDPOINT = '/reservations/{0}/poll/'

/**
 * Changes the reservation
 * @type {Function}
 */
export const change = (data: Data): Promise<Reservation[]> => {
  const pollEndpoint = format(POLL_RESERVATION_ENDPOINT, data.search_id)

  const createPoller = poller({
    initPoll: () =>
      client.post(CHANGE_RESERVATION_ENDPOINT, {
        body: data,
        baseUrl: config.BASE_URL_RESERVATIONS,
      }),
    pollNext: () =>
      client.get(pollEndpoint, { baseUrl: config.BASE_URL_RESERVATIONS }),
    builder: (res) => res.reservations.map(reservationBuilder),
    isMoreComing: (res) => res.status === 'pending',
    isResultEmpty: (res) =>
      !res || !res.reservations || !res.reservations.length,
    isError: (res) =>
      res &&
      res.status === 'trip_price_changed' &&
      new APIError('', res.status, 400),
    pollAll: true,
  })

  return createPoller()
}

export default change
